import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const heroSlider = () => {
    const sliders = document.querySelectorAll('.js-hero-section-slider');

    if ( sliders ) {
        sliders.forEach(slider => {
            const swiper = new Swiper(slider, {
                slidesPerView: 1,
                loop: true,
                effect: 'fade',
                speed: 600,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                a11y: true
            });
        });
    }
}

heroSlider();